<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Employers</h4>
        </div>
        <div class="card-body">
          <div class="row border-bottom border-top py-3 bg-light">
            <div class="col-md-4">
              <BFormInput
                @input="applyFilters"
                v-model="filters.id"
                placeholder="ID"
              />
            </div>
            <div class="col-md-4">
              <BFormInput
                @input="applyFilters"
                v-model="filters.name"
                placeholder="Name"
              />
            </div>
            <div class="col-md-4">
              <BFormInput
                @input="applyFilters"
                v-model="filters.email"
                placeholder="Email"
              />
            </div>
          </div>
          <div>
            <BTable :items="users" :fields="fields" :busy="isTableBusy">
              <div slot="table-busy" class="text-center my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
              <template v-slot:head()="data">
                <span class="text-info">{{ data.label }}</span>
              </template>
              <template v-slot:cell(full_name)="data">
                <router-link
                  :to="{ name: 'employer', params: { userId: data.item.id } }"
                  >{{ data.item.full_name }}</router-link
                >
              </template>
              <template v-slot:cell(email)="data">
                <router-link
                  :to="{ name: 'employer', params: { userId: data.item.id } }"
                  >{{ data.item.email }}</router-link
                >
              </template>
            </BTable>
            <BPagination
              :disabled="isTableBusy"
              v-model="currentPage"
              @input="setUsers"
              :total-rows="total"
              :per-page="perPage"
              align="center"
              aria-controls="users-table"
            ></BPagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BTable, BSpinner, BPagination, BFormInput } from "bootstrap-vue";

export default {
  components: {
    BTable,
    BSpinner,
    BPagination,
    BFormInput
  },
  data() {
    return {
      requestParams: {
        currentPage: 1,
        perPage: 10,
        filters: {
          id: null,
          email: null
        }
      },
      filters: {
        id: null,
        email: null
      },
      users: [],
      currentPage: 1,
      perPage: 10,
      total: 0,
      isTableBusy: true,
      disableButtons: false,
      spinningButtonId: undefined,
      fields: [
        "id",
        { key: "full_name", label: "name" },
        { key: "email", label: "email" },
        { key: "created_at", label: "date" }
      ]
    };
  },
  methods: {
    applyFilters() {
      this.currentPage = 1;
      this.setUsers();
    },
    setUsers() {
      this.isTableBusy = true;
      this.$http
        .get(`/enroll_admin/users`, {
          params: {
            page: this.currentPage,
            per_page: this.perPage,
            filters: this.filters
          }
        })
        .then(({ data }) => {
          this.currentPage = data.current_page;
          this.total = data.total;
          this.users = data.data;
        })
        .finally(() => (this.isTableBusy = false));
    }
  },
  created() {
    this.setUsers();
  }
};
</script>

<style scoped></style>
